<template>
<svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-LuoDiDeng`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.40106 1.97559C7.63982 1.97559 7.02271 2.5927 7.02271 3.35394V3.51466C7.02271 6.07868 8.86679 8.212 11.301 8.66065V21.8093H9.54992C9.06391 21.8093 8.66992 22.2033 8.66992 22.6893C8.66992 23.1753 9.06391 23.5693 9.54992 23.5693H14.9612C15.4472 23.5693 15.8412 23.1753 15.8412 22.6893C15.8412 22.2033 15.4472 21.8093 14.9612 21.8093H13.061V8.6859C13.3962 8.63411 13.721 8.55051 14.032 8.43827V9.71473C14.032 10.2007 14.426 10.5947 14.912 10.5947C15.398 10.5947 15.792 10.2007 15.792 9.71473V7.37169C16.8347 6.41512 17.4884 5.04123 17.4884 3.51466V3.35394C17.4884 2.5927 16.8713 1.97559 16.11 1.97559H8.40106ZM8.9774 3.69629C8.87177 3.69629 8.78613 3.78192 8.78613 3.88755C8.78613 5.61289 10.1848 7.01155 11.9101 7.01155H12.601C14.3263 7.01155 15.725 5.61289 15.725 3.88755C15.725 3.78192 15.6393 3.69629 15.5337 3.69629H8.9774Z" :fill="useCurrentColor ? 'currentColor' : '#1A1A1A'"/><path opacity=".4" d="M11.876 7.00391C10.1698 7.00391 8.78662 5.62076 8.78662 3.91456C8.78662 3.79347 8.88478 3.69531 9.00587 3.69531L15.5619 3.69531C15.6475 3.69531 15.7176 3.76338 15.7201 3.84894C15.7704 5.57633 14.3838 7.00391 12.6556 7.00391H11.876Z" :fill="useCurrentColor ? 'currentColor' : '#A85EE7'"/></svg>
</template>
<script>

export default {
  name: 'IconLuoDiDeng',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
